// PhotoSwipe initialization
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

const domStructure = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="pswp__bg"></div>
  <div class="pswp__scroll-wrap">
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">
        <div class="pswp__counter"></div>
        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
        <button class="pswp__button pswp__button--share" title="Share"></button>
        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
        <div class="pswp__share-tooltip"></div>
      </div>
      <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
      <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
      <div class="pswp__caption">
        <div class="pswp__caption__center"></div>
      </div>
    </div>
  </div>
</div>`;

function initPhotoSwipeFromDOM(gallerySelector) {
  const parseThumbnailElements = (el) => {
    const thumbElements = el.childNodes;
    const items = [];

    for (let i = 0; i < thumbElements.length; i++) {
      const figureEl = thumbElements[i];
      if (figureEl.nodeType !== 1) continue;

      const linkEl = figureEl.children[0];
      const size = linkEl.getAttribute('data-size').split('x');

      const item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };

      if (figureEl.children.length > 1) {
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl;
      items.push(item);
    }

    return items;
  };

  const closest = (el, fn) => el && (fn(el) ? el : closest(el.parentNode, fn));

  const onThumbnailsClick = (e) => {
    e.preventDefault();

    const eTarget = e.target || e.srcElement;
    const clickedListItem = closest(eTarget, (el) => el.tagName && el.tagName.toUpperCase() === 'FIGURE');

    if (!clickedListItem) return;

    const clickedGallery = clickedListItem.parentNode;
    const childNodes = clickedListItem.parentNode.childNodes;
    let nodeIndex = 0;
    let index;

    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType !== 1) continue;
      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (index >= 0) {
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  const openPhotoSwipe = (index, galleryElement, disableAnimation, fromURL) => {
    const pswpElement = document.querySelectorAll('.pswp')[0];
    const items = parseThumbnailElements(galleryElement);

    const options = {
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      getThumbBoundsFn: (index) => {
        const thumbnail = items[index].el.getElementsByTagName('img')[0];
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    };

    if (fromURL) {
      options.index = parseInt(index, 10) - 1;
    } else {
      options.index = parseInt(index, 10);
    }

    if (isNaN(options.index)) return;
    if (disableAnimation) options.showAnimationDuration = 0;

    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };

  const galleryElements = document.querySelectorAll(gallerySelector);

  for (let i = 0; i < galleryElements.length; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  const hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }

  function photoswipeParseHash() {
    const hash = window.location.hash.substring(1);
    const params = {};

    if (hash.length < 5) return params;

    const vars = hash.split('&');
    for (let i = 0; i < vars.length; i++) {
      if (!vars[i]) continue;
      const pair = vars[i].split('=');
      if (pair.length < 2) continue;
      params[pair[0]] = pair[1];
    }

    if (params.gid) params.gid = parseInt(params.gid, 10);
    return params;
  }
}

document.addEventListener("turbo:load", function() {
  const galleries = document.querySelectorAll('.c-photoswipe');
  if (galleries.length) {
    if (!document.querySelector('.pswp')) {
      document.body.insertAdjacentHTML('beforeend', domStructure);
    }
    initPhotoSwipeFromDOM('.c-photoswipe');
  }
});
